var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            close: _vm.closeDialog,
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.method != "add"
            ? _c(
                "el-button",
                {
                  staticClass: "mb8",
                  attrs: {
                    size: "medium",
                    icon: "el-icon-edit",
                    type: "warning",
                    disabled: !_vm.hasPermission("unmspace:cecUnmSpace:edit"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handEditorView(_vm.method)
                    },
                  },
                },
                [_vm._v("编辑")]
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "排序",
                            prop: "sort",
                            rules: [
                              {
                                required: true,
                                message: "排序不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写排序" },
                            model: {
                              value: _vm.inputForm.sort,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sort", $$v)
                              },
                              expression: "inputForm.sort",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [
                              {
                                required: true,
                                message: "中文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写中文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "英文名称",
                            prop: "nameEn",
                            rules: [
                              {
                                required: true,
                                message: "英文名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请填写英文名称",
                              maxlength: "64",
                            },
                            model: {
                              value: _vm.inputForm.nameEn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameEn", $$v)
                              },
                              expression: "inputForm.nameEn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "类型",
                            prop: "type",
                            rules: [
                              {
                                required: true,
                                message: "类型不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.inputForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "type", $$v)
                                },
                                expression: "inputForm.type",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList("cec_room"),
                              function (item) {
                                return _c("el-option", {
                                  key: item.id,
                                  attrs: { label: item.label, value: item.id },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "包含功能空间",
                            prop: "functionalSpaceIds.id",
                            rules: [
                              {
                                required: true,
                                message: "功能空间不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            attrs: {
                              title: "选择功能空间",
                              labelName: "nameEn",
                              disabled: _vm.method === "view",
                              labelValue: "id",
                              value: _vm.inputForm.functionalSpaceIds.id,
                              limit: 10,
                              columns: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                                {
                                  prop: "nameEn",
                                  label: "英文名称",
                                },
                              ],
                              dataListUrl:
                                "/unmspace/cecUnmFunctionalSpace/list",
                              queryEntityUrl:
                                "/unmspace/cecUnmFunctionalSpace/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.functionalSpaceIds.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "包含项目",
                            prop: "projectIds.id",
                            rules: [
                              {
                                required: true,
                                message: "包含项目不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("GridSelect", {
                            attrs: {
                              title: "选择包含项目",
                              labelName: "nameCn",
                              labelValue: "id",
                              value: _vm.inputForm.projectIds.id,
                              limit: 10,
                              showType: "table",
                              columns: [
                                {
                                  prop: "code",
                                  label: "编码",
                                },
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "code",
                                  label: "编码",
                                },
                                {
                                  prop: "nameCn",
                                  label: "中文名称",
                                },
                              ],
                              dataListUrl: "/unmspace/cecUnmProject/list",
                              queryEntityUrl:
                                "/unmspace/cecUnmProject/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.projectIds.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.method === "edit" || _vm.method === "view"
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "图片", prop: "", rules: [] } },
                            [
                              _c("ImageUploadCustom", {
                                attrs: {
                                  multiple: false,
                                  disabled: _vm.method === "view",
                                  otherPrams: _vm.otherPrams,
                                  action: "/unmfile/cecUnmFileupload",
                                  tip: "单个图片不要超过10M",
                                },
                                model: {
                                  value: _vm.inputForm.pic,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.inputForm, "pic", $$v)
                                  },
                                  expression: "inputForm.pic",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }